// extracted by mini-css-extract-plugin
export default {"paths":"Page_paths__6s9Mg","card":"Page_card__FF4iY","tabCard":"Page_tabCard__UxvRX","tabCrad":"Page_tabCrad__s8o5m","page":"Page_page__ludVm","body":"Page_body__15Lft"};